export default {
    name: {
      type: String,
      required: true
    },
    id: {
      type: String,
    },
    label: {
      type: String,
      default: null
    },
    value: {
      type: [String, Number, Boolean, Array, Object],
      default: null
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: [String, Array],
      default: null
    },
    tabindex: {
      default:null
    },
    autocomplete: {
      type: String,
      default: 'off'
    },
    hint: {
      type: String,
      default: null
    },

    groupClass: {
      type: [String, Array, Object],
      default: 'form-field'
    },
    groupErrorClass: {
      type: [String, Array, Object],
      default: 'is-invalid form-group-error'
    },
    inputClass: {
      type: [String, Array, Object],
      default: 'form-control'
    },
    inputErrorClass: {
      type: [String, Array, Object],
      default: 'is-invalid form-control-error'
    },
    errorClass: {
      type: [String, Array, Object],
      default: 'invalid-feedback'
    },

    validations: {
      type: Object,
      default: null
    },
    validator: {
      type: Function,
      default: null,
    },
    v: {
      type: Object,
      default: null
    },
    vRoot: {
      type: Object,
      default: null
    },

    customErrors: {
      type: [String, Array, Object],
      default: null
    }
  }
